export default __webpack_public_path__ + "static/media/ic-cupom.378ba235.svg";